import { Outlet, useLocation } from "react-router-dom";
import { BottomNav } from "./BottomNav";
import { CouponCart } from "@/components/coupon/CouponCart";

const HIDE_NAV_PATHS = ["/admin", "/payment/return"];

export function AppShell() {
  const location = useLocation();
  const hideNav = HIDE_NAV_PATHS.some((p) => location.pathname.startsWith(p));

  return (
    <div className="flex min-h-screen flex-col">
      <main className="flex-1 mx-auto w-full max-w-2xl px-4 pt-4 pb-32 safe-top">
        <Outlet />
      </main>
      <CouponCart />
      {!hideNav && <BottomNav />}
    </div>
  );
}
